import { useEffect, useState } from "react";
import styles from "./admin-panel.module.css";
import AdminDashboard from "./admin-dashboard";
import Login from "../../components/AdminPanel/Login/login";
import { ILogin } from "../../interfaces/login";

const AdminPanel = () => {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);

  const onClickLogin = async (input: ILogin) => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      if (!apiUrl) {
        console.error("Erro: API URL não definida.");
        return;
      }

      const response = await fetch(`${apiUrl}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: input.email, password: input.password }),
      });

      const resData = await response.json();

      if (!response.ok) {
        alert(
          resData.message + " " + resData.details || "Erro ao efetuar login"
        );
        return;
      }

      if (resData.data.token) {
        const userData = {
          token: resData.data.token,
          _id: resData.data._id,
        };

        document.cookie = `token=${userData.token}`;

        setIsLoggedIn(true);
      } else {
        alert("Email ou senha inválidos");
        return;
      }
    } catch (error) {
      alert("Erro ao realizar login:" + error);
    }
  };

  const onClickLogout = async () => {
    const getCookie = (name: string) => {
      const match = document.cookie.match(`(^|;)\\s*${name}=([^;]+)`);
      return match ? match[2] : null;
    };

    const token = getCookie("token");
    if (!token) {
      console.error("Erro: Token não encontrado.");
      return setIsLoggedIn(false);
    }

    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      if (!apiUrl) {
        console.error("Erro: API URL não definida.");
        return;
      }

      const response = await fetch(`${apiUrl}/logout`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const resData = await response.json();
      console.log(resData);

      document.cookie =
        "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      return setIsLoggedIn(false);
    } catch (error) {
      console.error("Erro ao realizar logout:", error);
      document.cookie =
        "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      return setIsLoggedIn(false);
    }
  };

  const validateToken = async (token: string) => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      if (!apiUrl) {
        console.error("Erro: API URL não definida.");
        return;
      }

      const response = await fetch(`${apiUrl}/auth-check`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const resData = await response.json();

      if (!response.ok) {
        alert(
          `${resData.message} ${resData.details}` || "Erro ao validar token."
        );
        return;
      }

      return resData.data;
    } catch (error) {
      alert("Erro ao validar token: " + error);
    }
  };

  useEffect(() => {
    const getCookie = (name: string) => {
      const match = document.cookie.match(`(^|;)\\s*${name}=([^;]+)`);
      return match ? match[2] : null;
    };

    const token = getCookie("token");
    if (token) {
      validateToken(token)
        .then((isValid) => {
          if (isValid) {
            setIsLoggedIn(true);
          } else {
            document.cookie =
              "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            setIsLoggedIn(false);
          }
        })
        .catch((error) => {
          console.log("Erro ao validar token: ", error);
          setIsLoggedIn(false);
        });
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  return (
    <section className={isLoggedIn ? styles.adminPanel : styles.loginPage}>
      {isLoggedIn ? (
        <AdminDashboard onClickLogout={onClickLogout} />
      ) : (
        <>
          <div className={styles.login_box}>
            <Login onClickLogin={onClickLogin} />
          </div>
          <div className={styles.background}></div>
        </>
      )}
    </section>
  );
};

export default AdminPanel;
